import { render, staticRenderFns } from "./search-products-landing.vue?vue&type=template&id=146ffe53&scoped=true&"
import script from "./search-products-landing.vue?vue&type=script&lang=js&"
export * from "./search-products-landing.vue?vue&type=script&lang=js&"
import style0 from "./search-products-landing.vue?vue&type=style&index=0&id=146ffe53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146ffe53",
  null
  
)

export default component.exports